import script from "./goRinSyo0027.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0027.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0027.vue?vue&type=style&index=0&id=d033ffd2&lang=scss"

const __exports__ = script;

export default __exports__